import React, { useEffect, useState } from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { StateProvider } from "../../../../components/SharedContext";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import "./key-events.m.css";

const KeyEventCard = (props) => {
  const { card = {}, story } = props;
  const { "story-elements": storyElements = [], id } = card;
  const firstTitleInCard = storyElements?.find((element) => element.type === "title");

  const scrollToCard = (event) => {
    event.preventDefault();
    const cardToView = document.getElementById(`${story?.slug}-${id}`);
    cardToView.style.scrollMargin = "80px";
    cardToView.scrollIntoView({ behavior: "smooth", block: "start", inline: "center" });
  };
  return (
    <a href="#" onClick={scrollToCard} styleName="highlights">
      <ul>{firstTitleInCard && <li>{firstTitleInCard?.text}</li>}</ul>
    </a>
  );
};

KeyEventCard.propTypes = {
  card: PropTypes.shape({
    "card-added-at": PropTypes.number,
    "story-elements": PropTypes.array,
    id: PropTypes.string,
  }),
  slug: PropTypes.string,
  index: PropTypes.number,
};

const KeyEvents = ({ story = {} }) => {
  const cards = get(story, ["cards"], []);
  const initialLoadCount = 4;
  const [initialCount, updatedCount] = useState(initialLoadCount);
  const [keyEventCards, setKeyEventCards] = useState([]);

  const cardsWithKeyEvents = cards.filter((card) => get(card?.metadata, ["attributes", "key-event"]));
  const hasmore = cardsWithKeyEvents.length > initialCount;

  const handleClick = () => {
    updatedCount(initialCount + initialLoadCount);
  };

  if (cardsWithKeyEvents.length < 1) {
    return null;
  }

  useEffect(() => {
    setKeyEventCards(cardsWithKeyEvents.slice(0, initialCount));
  }, [initialCount, cards?.length]);

  return (
    <div styleName="events-container">
      <div styleName="cards-wrapper">
        {keyEventCards.map((card, source) => (
          <KeyEventCard cardLength={source.length} card={card} key={card.id} story={story} />
        ))}
      </div>
      {hasmore && (
        <div styleName="show-more-div" onClick={handleClick}>
          <SvgIconHandler
            type="point-arrow"
            iconStyle={{ color: "#303D43" }}
            width="16px"
            height="16px"
            viewBox="0 0 16 16"
          />
          <span>SHOW MORE</span>
        </div>
      )}
    </div>
  );
};

KeyEvents.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  showLoadMore: PropTypes.bool,
};

export default StateProvider(KeyEvents);
